function PlanGG({ ...props }) {
	return (
		<g {...props} id="unit-gg">
			<g id="furniture">
				<polyline
					points="651.09 344.69 651.09 347.12 646.27 347.12 646.27 344.69 651.09 344.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="557.09"
					y1="503.35"
					x2="685.18"
					y2="503.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.81"
					y1="470.64"
					x2="664.58"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.44"
					y1="470.64"
					x2="656.21"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.06"
					y1="470.64"
					x2="647.83"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.69"
					y1="470.64"
					x2="639.45"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.31"
					y1="470.64"
					x2="631.08"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.94"
					y1="470.64"
					x2="622.7"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.56"
					y1="470.64"
					x2="614.33"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.19"
					y1="470.64"
					x2="605.95"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.09"
					y1="479.1"
					x2="557.09"
					y2="484.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.09"
					y1="487.48"
					x2="557.09"
					y2="492.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.09"
					y1="495.85"
					x2="557.09"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.09"
					y1="501.17"
					x2="560.94"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.08"
					y1="501.17"
					x2="569.31"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.45"
					y1="501.17"
					x2="577.68"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.82"
					y1="501.17"
					x2="586.06"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.2"
					y1="501.17"
					x2="594.43"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.58"
					y1="501.17"
					x2="602.81"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.95"
					y1="501.17"
					x2="611.19"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.33"
					y1="501.17"
					x2="619.56"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.7"
					y1="501.17"
					x2="627.94"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.08"
					y1="501.17"
					x2="636.31"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.45"
					y1="501.17"
					x2="644.69"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.83"
					y1="501.17"
					x2="653.06"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.21"
					y1="501.17"
					x2="661.44"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.58"
					y1="501.17"
					x2="669.81"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.95"
					y1="501.17"
					x2="678.19"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.33"
					y1="501.17"
					x2="685.18"
					y2="501.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.18"
					y1="501.17"
					x2="685.18"
					y2="495.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.84"
					y1="754.11"
					x2="319.84"
					y2="677.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="754.11"
					x2="317.66"
					y2="750.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="747.77"
					x2="317.66"
					y2="742.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="739.4"
					x2="317.66"
					y2="734.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="731.02"
					x2="317.66"
					y2="725.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="722.65"
					x2="317.66"
					y2="717.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="714.27"
					x2="317.66"
					y2="709.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="705.9"
					x2="317.66"
					y2="700.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="697.52"
					x2="317.66"
					y2="692.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="689.15"
					x2="317.66"
					y2="683.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.66"
					y1="680.77"
					x2="317.66"
					y2="677.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.58"
					y1="444.21"
					x2="711.27"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="349.56"
					x2="658.93"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="391.86"
					x2="447.06"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="349.56"
					x2="685.1"
					y2="352.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="356.06"
					x2="685.1"
					y2="361.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="364.43"
					x2="685.1"
					y2="369.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="372.81"
					x2="685.1"
					y2="378.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="381.18"
					x2="685.1"
					y2="386.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="389.56"
					x2="685.1"
					y2="394.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="397.93"
					x2="685.1"
					y2="403.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="406.31"
					x2="685.1"
					y2="411.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="414.68"
					x2="685.1"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="331.31 570.2 277.43 570.2 277.43 516.31 331.31 516.31 331.31 570.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="365.45 53.08 318.24 53.08 318.24 53.51 365.45 53.51 365.45 53.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="365.45"
					y1="53.51"
					x2="365.45"
					y2="53.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.24"
					y1="53.51"
					x2="365.45"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.24"
					y1="53.08"
					x2="318.24"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.45"
					y1="53.08"
					x2="318.24"
					y2="53.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.24"
					y1="58.23"
					x2="363.73"
					y2="58.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.73"
					y1="53.51"
					x2="327.67"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="367.59 53.51 363.73 53.51 363.73 58.23 367.59 58.23 367.59 53.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="367.59"
					y1="58.23"
					x2="367.59"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.73"
					y1="58.23"
					x2="367.59"
					y2="58.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.73"
					y1="53.51"
					x2="363.73"
					y2="58.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.59"
					y1="53.51"
					x2="363.73"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.24"
					y1="54.37"
					x2="363.73"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="318.24"
					y1="53.51"
					x2="318.24"
					y2="53.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="369.31 53.08 365.45 53.08 365.45 53.51 367.59 53.51 367.59 57.8 369.31 57.8 369.31 53.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="369.31"
					y1="57.8"
					x2="369.31"
					y2="53.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.59"
					y1="57.8"
					x2="369.31"
					y2="57.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.59"
					y1="53.51"
					x2="367.59"
					y2="57.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.45"
					y1="53.51"
					x2="367.59"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.45"
					y1="53.08"
					x2="365.45"
					y2="53.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.31"
					y1="53.08"
					x2="365.45"
					y2="53.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="371.49 54.37 371.49 56.55 486.27 56.55 486.27 54.37 371.49 54.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="486.27"
					y1="54.37"
					x2="371.49"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.27"
					y1="56.55"
					x2="486.27"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.49"
					y1="56.55"
					x2="486.27"
					y2="56.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.49"
					y1="54.37"
					x2="371.49"
					y2="56.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="373.67 54.37 373.67 67.45 369.31 67.45 369.31 54.37 373.67 54.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="373.67"
					y1="67.45"
					x2="373.67"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.31"
					y1="67.45"
					x2="373.67"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.31"
					y1="54.37"
					x2="369.31"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.67"
					y1="54.37"
					x2="369.31"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="488.46 54.37 488.46 67.45 484.09 67.45 484.09 54.37 488.46 54.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="488.46"
					y1="67.45"
					x2="488.46"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.09"
					y1="67.45"
					x2="488.46"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.09"
					y1="54.37"
					x2="484.09"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.46"
					y1="54.37"
					x2="484.09"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.68 539.83 747.95 539.83 747.95 585.76 752.68 585.76 752.68 539.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="753.11 587.48 753.11 538.11 752.68 538.11 752.68 587.48 753.11 587.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.68"
					y1="587.48"
					x2="753.11"
					y2="587.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="538.11"
					x2="752.68"
					y2="587.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.11"
					y1="538.11"
					x2="752.68"
					y2="538.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.11"
					y1="587.48"
					x2="753.11"
					y2="538.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.96"
					y1="539.83"
					x2="747.96"
					y2="585.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="585.76"
					x2="752.68"
					y2="539.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="747.95 535.97 747.95 539.83 752.68 539.83 752.68 535.97 747.95 535.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.68"
					y1="535.97"
					x2="747.96"
					y2="535.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="539.83"
					x2="752.68"
					y2="535.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.96"
					y1="539.83"
					x2="752.68"
					y2="539.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.96"
					y1="535.97"
					x2="747.96"
					y2="539.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.68 589.63 752.68 585.76 747.95 585.76 747.95 589.63 752.68 589.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="747.96"
					y1="589.63"
					x2="752.68"
					y2="589.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.96"
					y1="585.76"
					x2="747.96"
					y2="589.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="585.76"
					x2="747.96"
					y2="585.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="589.63"
					x2="752.68"
					y2="585.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="539.83"
					x2="751.82"
					y2="585.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="748.38 534.25 748.38 535.97 752.68 535.97 752.68 538.11 753.11 538.11 753.11 534.25 748.38 534.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="753.11"
					y1="534.25"
					x2="748.38"
					y2="534.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.11"
					y1="538.11"
					x2="753.11"
					y2="534.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="538.11"
					x2="753.11"
					y2="538.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="535.97"
					x2="752.68"
					y2="538.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="535.97"
					x2="752.68"
					y2="535.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="534.25"
					x2="748.38"
					y2="535.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="753.11 591.34 753.11 587.48 752.68 587.48 752.68 589.63 748.38 589.63 748.38 591.34 753.11 591.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="748.38"
					y1="591.34"
					x2="753.11"
					y2="591.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="589.63"
					x2="748.38"
					y2="591.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="589.63"
					x2="748.38"
					y2="589.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.68"
					y1="587.48"
					x2="752.68"
					y2="589.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.11"
					y1="587.48"
					x2="752.68"
					y2="587.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.11"
					y1="591.34"
					x2="753.11"
					y2="587.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.82 593.52 749.64 593.52 749.64 715.16 751.82 715.16 751.82 593.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="751.82"
					y1="715.16"
					x2="751.82"
					y2="593.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.64"
					y1="715.16"
					x2="751.82"
					y2="715.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.64"
					y1="593.52"
					x2="749.64"
					y2="715.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="593.52"
					x2="749.64"
					y2="593.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.82 534.25 738.73 534.25 738.73 529.88 751.82 529.88 751.82 534.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.73"
					y1="534.25"
					x2="751.82"
					y2="534.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.73"
					y1="529.88"
					x2="738.73"
					y2="534.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="529.88"
					x2="738.73"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="534.25"
					x2="751.82"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.82 595.71 738.73 595.71 738.73 591.34 751.82 591.34 751.82 595.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.73"
					y1="595.71"
					x2="751.82"
					y2="595.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.73"
					y1="591.34"
					x2="738.73"
					y2="595.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="591.34"
					x2="738.73"
					y2="591.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="595.71"
					x2="751.82"
					y2="591.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.82 717.34 738.73 717.34 738.73 712.98 751.82 712.98 751.82 717.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.73"
					y1="717.34"
					x2="751.82"
					y2="717.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.73"
					y1="712.98"
					x2="738.73"
					y2="717.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="712.98"
					x2="738.73"
					y2="712.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.82"
					y1="717.34"
					x2="751.82"
					y2="712.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="709.46 73.64 708.82 75.73 645.93 56.54 646.56 54.45 709.46 73.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.46"
					y1="73.64"
					x2="708.82"
					y2="75.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.82"
					y1="75.73"
					x2="645.93"
					y2="56.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.93"
					y1="56.54"
					x2="646.56"
					y2="54.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.56"
					y1="54.45"
					x2="709.46"
					y2="73.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.35 120.11 753.8 121.64 708.48 75.52 710.03 73.99 755.35 120.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.35"
					y1="120.11"
					x2="753.8"
					y2="121.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.8"
					y1="121.64"
					x2="708.48"
					y2="75.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.48"
					y1="75.52"
					x2="710.03"
					y2="73.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.03"
					y1="73.99"
					x2="755.35"
					y2="120.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.02 181.58 770.92 182.18 753.59 121.29 755.69 120.69 773.02 181.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.02"
					y1="181.58"
					x2="770.92"
					y2="182.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.92"
					y1="182.18"
					x2="753.59"
					y2="121.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.59"
					y1="121.29"
					x2="755.69"
					y2="120.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.69"
					y1="120.69"
					x2="773.02"
					y2="181.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="754.47 118.49 756.66 122.26 745.35 128.84 743.15 125.07 754.47 118.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="756.66"
					y1="122.26"
					x2="754.47"
					y2="118.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.35"
					y1="128.84"
					x2="756.66"
					y2="122.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.15"
					y1="125.07"
					x2="745.35"
					y2="128.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.47"
					y1="118.49"
					x2="743.15"
					y2="125.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="707.91 72.64 711.64 74.9 704.85 86.09 701.12 83.83 707.91 72.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="711.64"
					y1="74.9"
					x2="707.91"
					y2="72.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.85"
					y1="86.09"
					x2="711.64"
					y2="74.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.12"
					y1="83.83"
					x2="704.85"
					y2="86.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.91"
					y1="72.64"
					x2="701.12"
					y2="83.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.28"
					y1="913.27"
					x2="323.01"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="323.01"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="326.28"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="913.27"
					x2="412.44"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="412.44"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="409.17"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="408.07 914.36 412.44 914.36 412.44 913.27 408.07 913.27 408.07 914.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.38 913.27 323.01 913.27 323.01 914.36 327.38 914.36 327.38 913.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="408.07 895.82 412.44 895.82 412.44 894.73 408.07 894.73 408.07 895.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.38 894.73 323.01 894.73 323.01 895.82 327.38 895.82 327.38 894.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="408.07"
					y1="914.36"
					x2="412.44"
					y2="914.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.44"
					y1="914.36"
					x2="412.44"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.44"
					y1="913.27"
					x2="408.07"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.07"
					y1="913.27"
					x2="408.07"
					y2="914.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.38"
					y1="913.27"
					x2="323.01"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.01"
					y1="913.27"
					x2="323.01"
					y2="914.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.01"
					y1="914.36"
					x2="327.38"
					y2="914.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.38"
					y1="914.36"
					x2="327.38"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.07"
					y1="895.82"
					x2="412.44"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.44"
					y1="895.82"
					x2="412.44"
					y2="894.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.44"
					y1="894.73"
					x2="408.07"
					y2="894.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.07"
					y1="894.73"
					x2="408.07"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.38"
					y1="894.73"
					x2="323.01"
					y2="894.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.01"
					y1="894.73"
					x2="323.01"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.01"
					y1="895.82"
					x2="327.38"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.38"
					y1="895.82"
					x2="327.38"
					y2="894.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="406.99 913.27 408.62 913.27 408.62 895.82 406.99 895.82 406.99 913.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="326.83 913.27 328.47 913.27 328.47 895.82 326.83 895.82 326.83 913.27"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="383.99 840.3 328.47 895.82 331.17 898.52 386.69 843 383.99 840.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="408.62"
					y1="895.82"
					x2="409.17"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.62"
					y1="913.27"
					x2="409.17"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="409.17"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.83"
					y1="895.82"
					x2="326.28"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.83"
					y1="913.27"
					x2="326.28"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="326.28"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.99"
					y1="913.27"
					x2="406.99"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.99"
					y1="895.82"
					x2="408.62"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.62"
					y1="895.82"
					x2="408.62"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.62"
					y1="913.27"
					x2="406.99"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.83"
					y1="913.27"
					x2="326.83"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.83"
					y1="895.82"
					x2="328.47"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.47"
					y1="895.82"
					x2="328.47"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.47"
					y1="913.27"
					x2="326.83"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.99"
					y1="840.3"
					x2="386.69"
					y2="843"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.69"
					y1="843"
					x2="331.17"
					y2="898.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.17"
					y1="898.52"
					x2="328.47"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.47"
					y1="895.82"
					x2="383.99"
					y2="840.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="409.17"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="409.17"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="412.44"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="895.82"
					x2="412.44"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="913.27"
					x2="412.44"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="409.17"
					y1="913.27"
					x2="412.44"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="326.28"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="326.28"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="323.01"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="895.82"
					x2="323.01"
					y2="895.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="913.27"
					x2="323.01"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="326.28"
					y1="913.27"
					x2="323.01"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="488.46"
					y1="50"
					x2="488.46"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="645.33"
					y1="67.45"
					x2="645.33"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="677.58"
					x2="333.76"
					y2="677.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="745.92"
					x2="340.3"
					y2="745.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="689.21"
					x2="340.3"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="351.21"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="340.3"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="677.58"
					x2="340.3"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="351.21"
					y2="677.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="339.21 690.3 340.3 690.3 340.3 685.94 339.21 685.94 339.21 690.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="351.21 690.3 352.3 690.3 352.3 685.94 351.21 685.94 351.21 690.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.21"
					y1="690.3"
					x2="339.21"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="685.94"
					x2="340.3"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="685.94"
					x2="340.3"
					y2="690.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="690.3"
					x2="339.21"
					y2="690.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="744.83"
					x2="340.3"
					y2="744.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="690.3"
					x2="351.21"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="685.94"
					x2="352.3"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.3"
					y1="685.94"
					x2="352.3"
					y2="690.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.3"
					y1="690.3"
					x2="351.21"
					y2="690.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="744.83"
					x2="352.3"
					y2="744.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="340.3 691.39 351.21 691.39 351.21 689.75 340.3 689.75 340.3 691.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="340.3 745.37 351.21 745.37 351.21 743.74 340.3 743.74 340.3 745.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="388.22 706.72 385.52 704.02 348.51 741.04 351.21 743.74 388.22 706.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="351.21"
					y1="689.75"
					x2="351.21"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="689.75"
					x2="340.3"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="340.3"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="745.37"
					x2="351.21"
					y2="745.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="745.37"
					x2="340.3"
					y2="745.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="745.92"
					x2="340.3"
					y2="745.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="691.39"
					x2="351.21"
					y2="691.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="691.39"
					x2="351.21"
					y2="689.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="689.75"
					x2="340.3"
					y2="689.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="689.75"
					x2="340.3"
					y2="691.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="745.37"
					x2="351.21"
					y2="745.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="745.37"
					x2="351.21"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="743.74"
					x2="340.3"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="743.74"
					x2="340.3"
					y2="745.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.22"
					y1="706.72"
					x2="385.52"
					y2="704.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.52"
					y1="704.02"
					x2="348.51"
					y2="741.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.51"
					y1="741.04"
					x2="351.21"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="743.74"
					x2="388.22"
					y2="706.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="340.3"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="340.3"
					y2="689.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="351.21"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="689.21"
					x2="351.21"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="689.21"
					x2="340.3"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="689.21"
					x2="340.3"
					y2="685.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="745.92"
					x2="340.3"
					y2="745.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="745.92"
					x2="340.3"
					y2="745.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="513.02"
					x2="340.3"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="351.21"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="340.3"
					y2="513.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="574.09"
					x2="340.3"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="351.21"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="340.3"
					y2="574.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="339.21 573 339.21 577.36 340.3 577.36 340.3 573 339.21 573"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="340.3 514.11 340.3 509.75 339.21 509.75 339.21 514.11 340.3 514.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="351.21 573 351.21 577.36 352.3 577.36 352.3 573 351.21 573"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="352.3 514.11 352.3 509.75 351.21 509.75 351.21 514.11 352.3 514.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.21"
					y1="573"
					x2="339.21"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="577.36"
					x2="340.3"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="577.36"
					x2="340.3"
					y2="573"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="573"
					x2="339.21"
					y2="573"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="514.11"
					x2="340.3"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="509.75"
					x2="339.21"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="509.75"
					x2="339.21"
					y2="514.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="514.11"
					x2="340.3"
					y2="514.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="573"
					x2="351.21"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="577.36"
					x2="352.3"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.3"
					y1="577.36"
					x2="352.3"
					y2="573"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.3"
					y1="573"
					x2="351.21"
					y2="573"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.3"
					y1="514.11"
					x2="352.3"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.3"
					y1="509.75"
					x2="351.21"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="509.75"
					x2="351.21"
					y2="514.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="514.11"
					x2="352.3"
					y2="514.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="340.3 571.9 340.3 573.54 351.21 573.54 351.21 571.9 340.3 571.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="340.3 513.56 340.3 515.2 351.21 515.2 351.21 513.56 340.3 513.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="391.31 555.3 351.21 515.2 348.51 517.9 388.61 558 391.31 555.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="351.21"
					y1="573.54"
					x2="351.21"
					y2="574.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="573.54"
					x2="340.3"
					y2="574.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="340.3"
					y2="574.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="513.56"
					x2="351.21"
					y2="513.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="513.56"
					x2="340.3"
					y2="513.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="340.3"
					y2="513.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="571.9"
					x2="351.21"
					y2="571.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="571.9"
					x2="351.21"
					y2="573.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="573.54"
					x2="340.3"
					y2="573.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="573.54"
					x2="340.3"
					y2="571.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="513.56"
					x2="351.21"
					y2="513.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="513.56"
					x2="351.21"
					y2="515.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="515.2"
					x2="340.3"
					y2="515.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.3"
					y1="515.2"
					x2="340.3"
					y2="513.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.31"
					y1="555.3"
					x2="388.61"
					y2="558"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.61"
					y1="558"
					x2="348.51"
					y2="517.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.51"
					y1="517.9"
					x2="351.21"
					y2="515.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="515.2"
					x2="391.31"
					y2="555.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="340.3"
					y2="574.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="340.3"
					y2="574.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="351.21"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="574.09"
					x2="351.21"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="574.09"
					x2="340.3"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="574.09"
					x2="340.3"
					y2="577.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="340.3"
					y2="513.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="340.3"
					y2="513.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="351.21"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.21"
					y1="513.02"
					x2="351.21"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="513.02"
					x2="340.3"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="340.3"
					y1="513.02"
					x2="340.3"
					y2="509.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="659.31"
					y1="906.48"
					x2="659.31"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="659.31"
					y1="906.48"
					x2="670.22"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="726.3"
					y1="906.48"
					x2="670.22"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="726.3"
					y1="775.71"
					x2="726.3"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="738.73"
					y1="717.34"
					x2="749.64"
					y2="717.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="759.98"
					y1="717.34"
					x2="749.64"
					y2="717.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="518.98"
					x2="673.18"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="521.16"
					x2="670.46"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="529.88"
					x2="673.18"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="529.88"
					x2="670.46"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="518.98"
					x2="566.31"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="521.16"
					x2="569.04"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="529.88"
					x2="566.31"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="529.88"
					x2="569.04"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="685.18"
					y1="518.98"
					x2="670.46"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="518.98"
					x2="557.09"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.18"
					y1="529.88"
					x2="569.04"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="570.67 521.16 570.67 518.98 569.58 518.98 569.58 521.16 570.67 521.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="570.67 517.89 566.31 517.89 566.31 518.98 570.67 518.98 570.67 517.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="669.91 521.16 669.91 518.98 668.82 518.98 668.82 521.16 669.91 521.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="668.82 518.98 673.18 518.98 673.18 517.89 668.82 517.89 668.82 518.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="570.67 529.88 566.31 529.88 566.31 532.61 570.67 532.61 570.67 529.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="668.82 532.61 673.18 532.61 673.18 529.88 668.82 529.88 668.82 532.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="570.67"
					y1="521.16"
					x2="570.67"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.67"
					y1="518.98"
					x2="569.58"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.58"
					y1="518.98"
					x2="569.58"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.58"
					y1="521.16"
					x2="570.67"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.67"
					y1="517.89"
					x2="566.31"
					y2="517.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.31"
					y1="517.89"
					x2="566.31"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.31"
					y1="518.98"
					x2="570.67"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.67"
					y1="518.98"
					x2="570.67"
					y2="517.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.91"
					y1="521.16"
					x2="669.91"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.91"
					y1="518.98"
					x2="668.82"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.82"
					y1="518.98"
					x2="668.82"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.82"
					y1="521.16"
					x2="669.91"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.82"
					y1="518.98"
					x2="673.18"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.18"
					y1="518.98"
					x2="673.18"
					y2="517.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.18"
					y1="517.89"
					x2="668.82"
					y2="517.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.82"
					y1="517.89"
					x2="668.82"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.67"
					y1="529.88"
					x2="566.31"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.31"
					y1="529.88"
					x2="566.31"
					y2="532.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.31"
					y1="532.61"
					x2="570.67"
					y2="532.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.67"
					y1="532.61"
					x2="570.67"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.82"
					y1="532.61"
					x2="673.18"
					y2="532.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.18"
					y1="532.61"
					x2="673.18"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.18"
					y1="529.88"
					x2="668.82"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.82"
					y1="529.88"
					x2="668.82"
					y2="532.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="573.94 521.16 569.58 521.16 569.58 529.88 573.94 529.88 573.94 521.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="669.91 521.16 665.55 521.16 665.55 529.88 669.91 529.88 669.91 521.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="617.56 529.88 665.55 529.88 665.55 526.07 617.56 526.07 617.56 529.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="600.11 526.07 648.1 526.07 648.1 522.25 600.11 522.25 600.11 526.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="569.58"
					y1="529.88"
					x2="569.04"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.58"
					y1="521.16"
					x2="569.04"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.04"
					y1="529.88"
					x2="569.04"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.91"
					y1="529.88"
					x2="670.46"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.91"
					y1="521.16"
					x2="670.46"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.46"
					y1="529.88"
					x2="670.46"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.94"
					y1="521.16"
					x2="573.94"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.94"
					y1="529.88"
					x2="569.58"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.58"
					y1="529.88"
					x2="569.58"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.58"
					y1="521.16"
					x2="573.94"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.91"
					y1="521.16"
					x2="669.91"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.91"
					y1="529.88"
					x2="665.55"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.55"
					y1="529.88"
					x2="665.55"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.55"
					y1="521.16"
					x2="669.91"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.56"
					y1="529.88"
					x2="617.56"
					y2="526.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.56"
					y1="526.07"
					x2="665.55"
					y2="526.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.55"
					y1="526.07"
					x2="665.55"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.55"
					y1="529.88"
					x2="617.56"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.11"
					y1="526.07"
					x2="600.11"
					y2="522.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.11"
					y1="522.25"
					x2="648.1"
					y2="522.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.1"
					y1="522.25"
					x2="648.1"
					y2="526.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.1"
					y1="526.07"
					x2="600.11"
					y2="526.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.04"
					y1="529.88"
					x2="569.04"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="529.88"
					x2="569.04"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="521.16"
					x2="569.04"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="529.88"
					x2="566.31"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="521.16"
					x2="569.04"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="518.98"
					x2="566.31"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="569.04"
					y1="518.98"
					x2="566.31"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="529.88"
					x2="670.46"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="529.88"
					x2="670.46"
					y2="521.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="521.16"
					x2="670.46"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="529.88"
					x2="673.18"
					y2="529.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="521.16"
					x2="670.46"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="518.98"
					x2="673.18"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="670.46"
					y1="518.98"
					x2="673.18"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.18"
					y1="529.88"
					x2="546.18"
					y2="518.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="479.54"
					x2="447.06"
					y2="479.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="447.06"
					y1="558.06"
					x2="447.06"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="457.96"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="447.06"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="445.97 556.97 445.97 561.33 447.06 561.33 447.06 556.97 445.97 556.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="457.96 556.97 457.96 561.33 459.05 561.33 459.05 556.97 457.96 556.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="445.97"
					y1="556.97"
					x2="445.97"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.97"
					y1="561.33"
					x2="447.06"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="561.33"
					x2="447.06"
					y2="556.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="556.97"
					x2="445.97"
					y2="556.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.97"
					y1="480.63"
					x2="447.06"
					y2="480.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="556.97"
					x2="457.96"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="561.33"
					x2="459.05"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.05"
					y1="561.33"
					x2="459.05"
					y2="556.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.05"
					y1="556.97"
					x2="457.96"
					y2="556.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="480.63"
					x2="459.05"
					y2="480.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="447.06 555.88 447.06 557.51 457.96 557.51 457.96 555.88 447.06 555.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="447.06 480.09 447.06 481.72 457.96 481.72 457.96 480.09 447.06 480.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="510.4 534.16 457.96 481.72 455.26 484.42 507.7 536.86 510.4 534.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="457.96"
					y1="557.51"
					x2="457.96"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="557.51"
					x2="447.06"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="447.06"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="480.09"
					x2="457.96"
					y2="479.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="480.09"
					x2="447.06"
					y2="479.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="479.54"
					x2="447.06"
					y2="479.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="555.88"
					x2="457.96"
					y2="555.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="555.88"
					x2="457.96"
					y2="557.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="557.51"
					x2="447.06"
					y2="557.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="557.51"
					x2="447.06"
					y2="555.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="480.09"
					x2="457.96"
					y2="480.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="480.09"
					x2="457.96"
					y2="481.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="481.72"
					x2="447.06"
					y2="481.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="481.72"
					x2="447.06"
					y2="480.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.4"
					y1="534.16"
					x2="507.7"
					y2="536.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.7"
					y1="536.86"
					x2="455.26"
					y2="484.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.26"
					y1="484.42"
					x2="457.96"
					y2="481.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="481.72"
					x2="510.4"
					y2="534.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="447.06"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="447.06"
					y2="558.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="457.96"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="558.06"
					x2="457.96"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="447.06"
					y1="558.06"
					x2="447.06"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="447.06"
					y1="558.06"
					x2="447.06"
					y2="561.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="479.54"
					x2="447.06"
					y2="479.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="457.96"
					y1="479.54"
					x2="447.06"
					y2="479.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="780.33"
					x2="513.48"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="524.39"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="513.48"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="858.85"
					x2="513.48"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="524.39"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="513.48"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="524.39"
					y2="775.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="775.71"
					x2="513.48"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="512.39 857.76 512.39 862.12 513.48 862.12 513.48 857.76 512.39 857.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="513.48 781.42 513.48 777.06 512.39 777.06 512.39 781.42 513.48 781.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="524.39 857.76 524.39 862.12 525.48 862.12 525.48 857.76 524.39 857.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="525.48 781.42 525.48 777.06 524.39 777.06 524.39 781.42 525.48 781.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="512.39"
					y1="857.76"
					x2="512.39"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.39"
					y1="862.12"
					x2="513.48"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="862.12"
					x2="513.48"
					y2="857.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="857.76"
					x2="512.39"
					y2="857.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="781.42"
					x2="513.48"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="777.06"
					x2="512.39"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.39"
					y1="777.06"
					x2="512.39"
					y2="781.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.39"
					y1="781.42"
					x2="513.48"
					y2="781.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="857.76"
					x2="524.39"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="862.12"
					x2="525.48"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.48"
					y1="862.12"
					x2="525.48"
					y2="857.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.48"
					y1="857.76"
					x2="524.39"
					y2="857.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.48"
					y1="781.42"
					x2="525.48"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.48"
					y1="777.06"
					x2="524.39"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="777.06"
					x2="524.39"
					y2="781.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="781.42"
					x2="525.48"
					y2="781.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="513.48 856.67 513.48 858.31 524.39 858.31 524.39 856.67 513.48 856.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="513.48 780.88 513.48 782.51 524.39 782.51 524.39 780.88 513.48 780.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="576.82 834.95 524.39 782.51 521.69 785.21 574.12 837.65 576.82 834.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="524.39"
					y1="858.31"
					x2="524.39"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="858.31"
					x2="513.48"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="513.48"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="780.88"
					x2="524.39"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="780.88"
					x2="513.48"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="513.48"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="856.67"
					x2="524.39"
					y2="856.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="856.67"
					x2="524.39"
					y2="858.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="858.31"
					x2="513.48"
					y2="858.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="858.31"
					x2="513.48"
					y2="856.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="780.88"
					x2="524.39"
					y2="780.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="780.88"
					x2="524.39"
					y2="782.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="782.51"
					x2="513.48"
					y2="782.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.48"
					y1="782.51"
					x2="513.48"
					y2="780.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.82"
					y1="834.95"
					x2="574.12"
					y2="837.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.12"
					y1="837.65"
					x2="521.69"
					y2="785.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.69"
					y1="785.21"
					x2="524.39"
					y2="782.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="782.51"
					x2="576.82"
					y2="834.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="513.48"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="513.48"
					y2="858.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="524.39"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="858.85"
					x2="524.39"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="858.85"
					x2="513.48"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="858.85"
					x2="513.48"
					y2="862.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="513.48"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="513.48"
					y2="780.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="524.39"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="524.39"
					y1="780.33"
					x2="524.39"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="780.33"
					x2="513.48"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="513.48"
					y1="780.33"
					x2="513.48"
					y2="777.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="447.06"
					y1="444.21"
					x2="457.96"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="711.27"
					y1="444.21"
					x2="457.96"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="711.27"
					y1="349.56"
					x2="722.18"
					y2="349.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="738.73"
					y1="244.39"
					x2="738.73"
					y2="233.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="738.73"
					y1="186.99"
					x2="738.73"
					y2="233.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="738.73"
					y1="186.99"
					x2="749.64"
					y2="186.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="759.98"
					y1="186.99"
					x2="749.64"
					y2="186.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="777.43"
					y1="182.1"
					x2="759.98"
					y2="182.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="759.98"
					y1="182.1"
					x2="759.98"
					y2="186.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="569.73 875.27 565.84 873.53 561.62 872.93 557.4 873.53 553.51 875.27 550.95 877.47 549 880.24 546.53 886.73 545.67 894.85 547.5 902.82 546.9 909.97 543.91 916.51 542.74 918.35 541.36 922.14 541.57 926.17 542.19 927.76 542.19 932 543.96 932 543.96 930.06 546.91 931.85 550.3 932.54 572.95 932.54 577.33 931.37 580.62 928.25 582.03 923.94 582.03 923.42 581.58 920.69 579.28 916.41 576.32 909.95 575.73 902.87 577.57 894.88 576.72 886.73 574.24 880.24 572.3 877.47 569.73 875.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="553.55"
					y1="912.41"
					x2="569.7"
					y2="912.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.95"
					y1="932.54"
					x2="561.62"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.95"
					y1="931.73"
					x2="561.62"
					y2="931.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.3"
					y1="932.54"
					x2="561.62"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.3"
					y1="931.73"
					x2="561.62"
					y2="931.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.28"
					y1="912.41"
					x2="569.28"
					y2="915.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.28"
					y1="915.42"
					x2="566.78"
					y2="915.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.78"
					y1="915.42"
					x2="566.78"
					y2="912.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.97"
					y1="912.41"
					x2="553.97"
					y2="915.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.97"
					y1="915.42"
					x2="556.47"
					y2="915.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.47"
					y1="915.42"
					x2="556.47"
					y2="912.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.96"
					y1="924.5"
					x2="543.96"
					y2="932"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.19"
					y1="924.5"
					x2="542.19"
					y2="932"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.19"
					y1="932"
					x2="543.96"
					y2="932"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.19"
					y1="924.5"
					x2="543.96"
					y2="924.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.62"
					y1="872.93"
					x2="564.33"
					y2="873.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.33"
					y1="873.24"
					x2="566.95"
					y2="873.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.95"
					y1="873.94"
					x2="569.73"
					y2="875.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.73"
					y1="875.27"
					x2="572.3"
					y2="877.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.3"
					y1="877.47"
					x2="574.24"
					y2="880.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.24"
					y1="880.24"
					x2="575.68"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.68"
					y1="883.39"
					x2="576.72"
					y2="886.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.72"
					y1="886.73"
					x2="577.66"
					y2="892.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.66"
					y1="892.13"
					x2="577.71"
					y2="894.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.71"
					y1="894.85"
					x2="577.4"
					y2="897.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.4"
					y1="897.57"
					x2="576.18"
					y2="901.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.18"
					y1="901.78"
					x2="574.27"
					y2="905.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="905.85"
					x2="572"
					y2="909.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572"
					y1="909.5"
					x2="569.7"
					y2="912.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.73"
					y1="902.87"
					x2="575.75"
					y2="906.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.75"
					y1="906.65"
					x2="576.38"
					y2="910.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.38"
					y1="910.33"
					x2="577.94"
					y2="914.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.94"
					y1="914.27"
					x2="579.76"
					y2="917.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.76"
					y1="917.13"
					x2="581.37"
					y2="920.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.37"
					y1="920.09"
					x2="582.01"
					y2="922.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.01"
					y1="922.98"
					x2="581.77"
					y2="925.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.77"
					y1="925.85"
					x2="580.65"
					y2="928.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.65"
					y1="928.47"
					x2="578.66"
					y2="930.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.66"
					y1="930.57"
					x2="576.73"
					y2="931.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.73"
					y1="931.64"
					x2="574.88"
					y2="932.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.88"
					y1="932.24"
					x2="572.95"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.95"
					y1="931.73"
					x2="573.82"
					y2="931.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.82"
					y1="931.65"
					x2="575.6"
					y2="931.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.6"
					y1="931.09"
					x2="577.17"
					y2="929.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.17"
					y1="929.77"
					x2="578.16"
					y2="927.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.16"
					y1="927.92"
					x2="578.63"
					y2="925.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.63"
					y1="925.49"
					x2="578.73"
					y2="922.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.73"
					y1="922.98"
					x2="578.72"
					y2="921.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.72"
					y1="921.74"
					x2="578.2"
					y2="920.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.2"
					y1="920.75"
					x2="577.58"
					y2="920.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.58"
					y1="920.46"
					x2="570.73"
					y2="918.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.73"
					y1="918.51"
					x2="567.32"
					y2="917.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.32"
					y1="917.93"
					x2="563.88"
					y2="917.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.88"
					y1="917.69"
					x2="561.62"
					y2="917.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.5"
					y1="902.82"
					x2="547.47"
					y2="906.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.47"
					y1="906.61"
					x2="546.85"
					y2="910.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.85"
					y1="910.31"
					x2="545.31"
					y2="914.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.31"
					y1="914.27"
					x2="543.5"
					y2="917.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.5"
					y1="917.14"
					x2="541.88"
					y2="920.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.88"
					y1="920.09"
					x2="541.35"
					y2="922.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.35"
					y1="922.01"
					x2="541.23"
					y2="924"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.23"
					y1="924"
					x2="541.5"
					y2="925.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.5"
					y1="925.94"
					x2="542.19"
					y2="927.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.3"
					y1="931.73"
					x2="549.43"
					y2="931.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.43"
					y1="931.65"
					x2="547.65"
					y2="931.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.65"
					y1="931.09"
					x2="546.08"
					y2="929.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.08"
					y1="929.77"
					x2="545.09"
					y2="927.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.09"
					y1="927.92"
					x2="544.62"
					y2="925.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.62"
					y1="925.49"
					x2="544.51"
					y2="922.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.51"
					y1="922.98"
					x2="544.53"
					y2="921.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.53"
					y1="921.74"
					x2="545.05"
					y2="920.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.05"
					y1="920.75"
					x2="545.66"
					y2="920.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.66"
					y1="920.46"
					x2="552.52"
					y2="918.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.52"
					y1="918.51"
					x2="555.93"
					y2="917.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.93"
					y1="917.93"
					x2="559.37"
					y2="917.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.37"
					y1="917.69"
					x2="561.62"
					y2="917.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.62"
					y1="872.93"
					x2="558.92"
					y2="873.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.92"
					y1="873.24"
					x2="556.3"
					y2="873.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.3"
					y1="873.94"
					x2="553.51"
					y2="875.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.51"
					y1="875.27"
					x2="550.94"
					y2="877.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.94"
					y1="877.47"
					x2="549"
					y2="880.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549"
					y1="880.24"
					x2="547.57"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.57"
					y1="883.39"
					x2="546.53"
					y2="886.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.53"
					y1="886.73"
					x2="545.59"
					y2="892.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.59"
					y1="892.13"
					x2="545.54"
					y2="894.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.54"
					y1="894.85"
					x2="545.85"
					y2="897.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.85"
					y1="897.57"
					x2="547.07"
					y2="901.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.07"
					y1="901.78"
					x2="548.98"
					y2="905.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.98"
					y1="905.85"
					x2="551.25"
					y2="909.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.25"
					y1="909.5"
					x2="553.55"
					y2="912.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.61"
					y1="918.52"
					x2="580.17"
					y2="917.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.17"
					y1="917.9"
					x2="578.93"
					y2="916.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.93"
					y1="916.98"
					x2="577.85"
					y2="916.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.85"
					y1="916.76"
					x2="570.89"
					y2="916.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.89"
					y1="916.17"
					x2="563.91"
					y2="915.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.91"
					y1="915.9"
					x2="561.62"
					y2="915.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.64"
					y1="918.52"
					x2="543.07"
					y2="917.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.07"
					y1="917.9"
					x2="544.32"
					y2="916.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.32"
					y1="916.98"
					x2="545.4"
					y2="916.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.4"
					y1="916.76"
					x2="552.36"
					y2="916.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.36"
					y1="916.17"
					x2="559.34"
					y2="915.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.34"
					y1="915.9"
					x2="561.62"
					y2="915.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.96"
					y1="930.06"
					x2="544.58"
					y2="930.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.58"
					y1="930.57"
					x2="546.52"
					y2="931.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.52"
					y1="931.64"
					x2="548.36"
					y2="932.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.36"
					y1="932.24"
					x2="550.3"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="587.8 932.54 587.8 931.67 583.44 931.67 583.44 932.54 587.8 932.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="583.44"
					y1="932.54"
					x2="587.8"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.44"
					y1="931.67"
					x2="583.44"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.8"
					y1="931.67"
					x2="583.44"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.8"
					y1="932.54"
					x2="587.8"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="535.45 932.54 539.81 932.54 539.81 931.67 535.45 931.67 535.45 932.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="535.45"
					y1="931.67"
					x2="535.45"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.81"
					y1="931.67"
					x2="535.45"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.81"
					y1="932.54"
					x2="539.81"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.45"
					y1="932.54"
					x2="539.81"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="586.05 931.67 586.05 924.58 585.18 924.58 585.18 931.67 586.05 931.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="585.18"
					y1="931.67"
					x2="586.05"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.18"
					y1="924.58"
					x2="585.18"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.05"
					y1="924.58"
					x2="585.18"
					y2="924.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.05"
					y1="931.67"
					x2="586.05"
					y2="924.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="537.2 931.67 538.07 931.67 538.07 924.58 537.2 924.58 537.2 931.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.2"
					y1="924.58"
					x2="537.2"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.07"
					y1="924.58"
					x2="537.2"
					y2="924.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.07"
					y1="931.67"
					x2="538.07"
					y2="924.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.2"
					y1="931.67"
					x2="538.07"
					y2="931.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="585.18 926.76 585.18 925.01 538.07 925.01 538.07 926.76 585.18 926.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="538.07"
					y1="926.76"
					x2="585.18"
					y2="926.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.07"
					y1="925.01"
					x2="538.07"
					y2="926.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.18"
					y1="925.01"
					x2="538.07"
					y2="925.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.18"
					y1="926.76"
					x2="585.18"
					y2="925.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="726.3 775.71 659.31 775.71 659.31 906.48 726.3 906.48 726.3 775.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="726.3"
					y1="906.48"
					x2="726.3"
					y2="775.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.31"
					y1="906.48"
					x2="726.3"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.31"
					y1="775.71"
					x2="659.31"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.3"
					y1="775.71"
					x2="659.31"
					y2="775.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.01"
					y1="902.18"
					x2="722.01"
					y2="780"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.01"
					y1="780"
					x2="663.61"
					y2="780"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.61"
					y1="780"
					x2="663.61"
					y2="902.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.61"
					y1="902.18"
					x2="722.01"
					y2="902.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.01"
					y1="902.18"
					x2="695.57"
					y2="847.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.61"
					y1="902.18"
					x2="690.05"
					y2="847.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.01"
					y1="780"
					x2="695.57"
					y2="834.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.61"
					y1="780"
					x2="690.05"
					y2="834.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.1"
					y1="841.09"
					x2="688.52"
					y2="841.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.81"
					y1="836.8"
					x2="692.81"
					y2="845.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m699.68,841.09c0-3.79-3.08-6.87-6.87-6.87s-6.87,3.07-6.87,6.87,3.08,6.87,6.87,6.87,6.87-3.08,6.87-6.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m697.1,841.09c0-2.37-1.92-4.29-4.29-4.29s-4.29,1.92-4.29,4.29,1.92,4.3,4.29,4.3,4.29-1.93,4.29-4.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="692.81 906.48 699.51 897.37 686.1 897.37 692.81 906.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="686.1"
					y1="897.37"
					x2="692.81"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.51"
					y1="897.37"
					x2="686.1"
					y2="897.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.81"
					y1="906.48"
					x2="699.51"
					y2="897.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.81"
					y1="895.29"
					x2="692.81"
					y2="889.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.81"
					y1="897.37"
					x2="686.1"
					y2="897.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.1"
					y1="897.37"
					x2="692.81"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.81"
					y1="897.37"
					x2="699.51"
					y2="897.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.51"
					y1="897.37"
					x2="692.81"
					y2="906.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.83"
					y1="895.46"
					x2="688.05"
					y2="890.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.79"
					y1="895.46"
					x2="697.57"
					y2="890.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="454.57 394.44 454.57 444.21 503.48 444.21 503.48 394.44 454.57 394.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="503.48"
					y1="394.44"
					x2="501.53"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.39"
					y1="394.44"
					x2="493.16"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.01"
					y1="394.44"
					x2="484.78"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.64"
					y1="394.44"
					x2="476.4"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.26"
					y1="394.44"
					x2="468.03"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.89"
					y1="394.44"
					x2="459.66"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="394.44"
					x2="454.57"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="444.21"
					x2="503.48"
					y2="441.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="438.69"
					x2="503.48"
					y2="433.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="430.32"
					x2="503.48"
					y2="425.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="421.94"
					x2="503.48"
					y2="416.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="413.57"
					x2="503.48"
					y2="408.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="405.19"
					x2="503.48"
					y2="399.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.48"
					y1="396.81"
					x2="503.48"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="444.21"
					x2="456.52"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.66"
					y1="444.21"
					x2="464.89"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.03"
					y1="444.21"
					x2="473.26"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.4"
					y1="444.21"
					x2="481.64"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.78"
					y1="444.21"
					x2="490.01"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.16"
					y1="444.21"
					x2="498.39"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.53"
					y1="444.21"
					x2="503.48"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="394.44"
					x2="454.57"
					y2="396.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="399.95"
					x2="454.57"
					y2="405.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="408.33"
					x2="454.57"
					y2="413.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="416.71"
					x2="454.57"
					y2="421.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="425.08"
					x2="454.57"
					y2="430.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="433.46"
					x2="454.57"
					y2="438.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.57"
					y1="441.83"
					x2="454.57"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.29 391.86 503.29 390.36 454.75 390.36 454.75 391.86 462.37 391.86 462.37 390.63 495.68 390.63 495.68 391.86 503.29 391.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="495.68"
					y1="391.86"
					x2="503.29"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="495.68"
					y1="390.63"
					x2="495.68"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="462.37"
					y1="390.63"
					x2="495.68"
					y2="390.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="462.37"
					y1="391.86"
					x2="462.37"
					y2="390.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="454.75"
					y1="391.86"
					x2="462.37"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="454.75"
					y1="390.36"
					x2="454.75"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="503.29"
					y1="390.36"
					x2="454.75"
					y2="390.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="503.29"
					y1="391.86"
					x2="503.29"
					y2="390.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="505.2 391.86 452.85 391.86 452.85 394.44 505.2 394.44 505.2 391.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="505.2"
					y1="394.44"
					x2="505.2"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="452.85"
					y1="394.44"
					x2="505.2"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="452.85"
					y1="391.86"
					x2="452.85"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="505.2"
					y1="391.86"
					x2="452.85"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="454.75"
					y1="391.86"
					x2="454.75"
					y2="390.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.75"
					y1="390.36"
					x2="503.29"
					y2="390.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.29"
					y1="390.36"
					x2="503.29"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.85"
					y1="391.86"
					x2="505.2"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.68"
					y1="391.86"
					x2="495.68"
					y2="390.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.68"
					y1="390.63"
					x2="462.37"
					y2="390.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.37"
					y1="390.63"
					x2="462.37"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.85"
					y1="394.44"
					x2="452.85"
					y2="391.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.2"
					y1="391.86"
					x2="505.2"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.2"
					y1="394.44"
					x2="452.85"
					y2="394.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="637.41 387.5 571.97 387.5 571.97 444.21 637.41 444.21 637.41 387.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="637.41"
					y1="387.5"
					x2="571.97"
					y2="387.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.41"
					y1="444.21"
					x2="571.97"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.41"
					y1="442.49"
					x2="571.97"
					y2="442.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.41"
					y1="387.5"
					x2="637.41"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.97"
					y1="387.5"
					x2="571.97"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.11"
					y1="390.08"
					x2="576.27"
					y2="390.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.27"
					y1="390.08"
					x2="574.55"
					y2="391.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.55"
					y1="391.8"
					x2="574.55"
					y2="439.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.55"
					y1="439.92"
					x2="576.27"
					y2="441.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.27"
					y1="441.63"
					x2="633.11"
					y2="441.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.11"
					y1="441.63"
					x2="634.83"
					y2="439.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.83"
					y1="439.92"
					x2="634.83"
					y2="391.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.83"
					y1="391.8"
					x2="633.11"
					y2="390.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m629.63,401.68c0-4.74-3.84-8.59-8.58-8.59s-8.59,3.84-8.59,8.59,3.84,8.58,8.59,8.58,8.58-3.84,8.58-8.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m627.49,430.03c0-3.56-2.88-6.44-6.44-6.44s-6.44,2.88-6.44,6.44,2.88,6.44,6.44,6.44,6.44-2.89,6.44-6.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m594.77,401.68c0-3.56-2.88-6.44-6.44-6.44s-6.44,2.88-6.44,6.44,2.88,6.44,6.44,6.44,6.44-2.88,6.44-6.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m596.92,430.03c0-4.74-3.84-8.58-8.59-8.58s-8.58,3.84-8.58,8.58,3.84,8.59,8.58,8.59,8.59-3.84,8.59-8.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.35"
					y1="276.44"
					x2="651.09"
					y2="276.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.09"
					y1="349.56"
					x2="730.35"
					y2="349.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.09"
					y1="276.44"
					x2="651.09"
					y2="349.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.55"
					y1="276.44"
					x2="656.55"
					y2="349.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="565.75 398.13 511.42 398.13 510.2 398.64 509.7 399.85 509.7 436.22 510.2 437.43 511.42 437.94 565.75 437.94 566.96 437.43 567.47 436.22 567.47 399.85 566.96 398.64 565.75 398.13"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m565.75,398.13c.95,0,1.72.77,1.72,1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.47"
					y1="436.22"
					x2="567.47"
					y2="399.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m567.47,436.22c0,.95-.77,1.72-1.72,1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.42"
					y1="437.94"
					x2="565.75"
					y2="437.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m511.42,437.94c-.95,0-1.72-.77-1.72-1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.7"
					y1="399.85"
					x2="509.7"
					y2="436.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m509.7,399.85c0-.95.77-1.72,1.72-1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.75"
					y1="398.13"
					x2="511.42"
					y2="398.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.45"
					y1="402.43"
					x2="515.71"
					y2="402.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514"
					y1="404.14"
					x2="514"
					y2="427.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.71"
					y1="429.35"
					x2="561.45"
					y2="429.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.17"
					y1="427.63"
					x2="563.17"
					y2="404.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.45"
					y1="402.43"
					x2="561.45"
					y2="402.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m514,404.14c0-.95.77-1.72,1.71-1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m515.71,429.35c-.95,0-1.71-.77-1.71-1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m563.17,427.63c0,.95-.77,1.72-1.72,1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m561.45,402.43c.95,0,1.72.77,1.72,1.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m541.16,420.76c0-1.42-1.16-2.57-2.58-2.57s-2.57,1.15-2.57,2.57,1.16,2.58,2.57,2.58,2.58-1.16,2.58-2.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="539.36 418.37 539.13 417.82 538.58 417.6 538.04 417.83 537.81 418.37 537.81 435.36 538.04 435.91 538.58 436.14 539.13 435.91 539.36 435.36 539.36 418.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="539.36"
					y1="435.36"
					x2="539.36"
					y2="418.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m539.36,435.36c0,.43-.34.77-.77.77s-.77-.34-.77-.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.81"
					y1="418.37"
					x2="537.81"
					y2="435.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m537.81,418.37h0c0-.43.34-.77.77-.77s.77.34.77.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="540.3 430.98 539.36 430.98 539.36 435.36 539.13 435.91 538.58 436.14 538.04 435.91 537.81 435.36 537.81 430.98 536.87 430.98 536.87 436.56 540.3 436.56 540.3 430.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="540.3"
					y1="436.56"
					x2="540.3"
					y2="430.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.87"
					y1="436.56"
					x2="540.3"
					y2="436.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.87"
					y1="430.98"
					x2="536.87"
					y2="436.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.81"
					y1="430.98"
					x2="536.87"
					y2="430.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.81"
					y1="435.36"
					x2="537.81"
					y2="430.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m539.36,435.36c0,.43-.34.77-.77.77s-.77-.34-.77-.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.36"
					y1="430.98"
					x2="539.36"
					y2="435.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.3"
					y1="430.98"
					x2="539.36"
					y2="430.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="540.28 427.89 539.36 427.89 539.36 430.9 540.28 430.9 540.28 427.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="540.28"
					y1="430.9"
					x2="540.28"
					y2="427.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.36"
					y1="430.9"
					x2="540.28"
					y2="430.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.36"
					y1="427.89"
					x2="539.36"
					y2="430.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.28"
					y1="427.89"
					x2="539.36"
					y2="427.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="536.89 427.89 536.89 430.9 537.81 430.9 537.81 427.89 536.89 427.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.81"
					y1="427.89"
					x2="536.89"
					y2="427.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.81"
					y1="430.9"
					x2="537.81"
					y2="427.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.89"
					y1="430.9"
					x2="537.81"
					y2="430.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.89"
					y1="427.89"
					x2="536.89"
					y2="430.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="656.51 888.94 599.81 888.94 599.81 932.54 656.51 932.54 656.51 888.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="656.51"
					y1="888.94"
					x2="599.81"
					y2="888.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.51"
					y1="932.54"
					x2="599.81"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.81"
					y1="888.94"
					x2="599.81"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.51"
					y1="888.94"
					x2="656.51"
					y2="932.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.51"
					y1="930.83"
					x2="599.81"
					y2="930.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.97"
					y1="899.29"
					x2="606.35"
					y2="899.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.35"
					y1="899.29"
					x2="606.35"
					y2="925.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.35"
					y1="925.47"
					x2="649.97"
					y2="925.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.97"
					y1="925.47"
					x2="649.97"
					y2="899.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.69"
					y1="897.58"
					x2="604.63"
					y2="897.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.63"
					y1="897.58"
					x2="604.63"
					y2="927.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.63"
					y1="927.18"
					x2="651.69"
					y2="927.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.69"
					y1="927.18"
					x2="651.69"
					y2="897.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m630.74,919.56c0-1.42-1.15-2.57-2.57-2.57s-2.58,1.15-2.58,2.57,1.16,2.58,2.58,2.58,2.57-1.16,2.57-2.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="630.31 930.19 629.96 926.59 629.68 925.77 629.11 921.22 628.8 920.63 628.16 920.38 627.52 920.63 627.21 921.22 626.64 925.77 626.36 926.59 626.01 930.19 626.42 931.45 627.5 932.23 628.82 932.23 629.9 931.45 630.31 930.19"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m630.31,930.19c0,1.19-.96,2.15-2.15,2.15s-2.15-.96-2.15-2.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.36"
					y1="926.59"
					x2="626.01"
					y2="930.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m626.36,926.59c.03-.29.12-.57.28-.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.21"
					y1="921.22"
					x2="626.64"
					y2="925.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m627.21,921.22c.06-.48.47-.84.95-.84s.89.36.95.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.68"
					y1="925.77"
					x2="629.11"
					y2="921.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m629.68,925.77c.16.24.25.53.28.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.31"
					y1="930.19"
					x2="629.96"
					y2="926.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.99"
					y1="928.05"
					x2="626.99"
					y2="926.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.33"
					y1="926.77"
					x2="629.33"
					y2="928.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.33"
					y1="928.05"
					x2="626.99"
					y2="928.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m626.99,926.77c0-.64.52-1.17,1.17-1.17s1.17.52,1.17,1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m626.64,925.77c.33-.52.91-.83,1.52-.83s1.19.31,1.52.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.35"
					y1="524.29"
					x2="327.32"
					y2="524.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.32"
					y1="524.29"
					x2="327.32"
					y2="562.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.35"
					y1="516.31"
					x2="313.35"
					y2="570.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.43"
					y1="570.2"
					x2="277.43"
					y2="516.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.43"
					y1="516.31"
					x2="331.31"
					y2="516.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.31"
					y1="570.2"
					x2="277.43"
					y2="570.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.32"
					y1="516.31"
					x2="330.32"
					y2="570.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.35"
					y1="562.21"
					x2="327.32"
					y2="562.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.31"
					y1="516.31"
					x2="331.31"
					y2="570.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.09"
					y1="347.12"
					x2="646.27"
					y2="347.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.27"
					y1="347.12"
					x2="646.27"
					y2="344.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.27"
					y1="344.69"
					x2="651.09"
					y2="344.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="276.44"
					x2="658.93"
					y2="278.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="281.07"
					x2="658.93"
					y2="286.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="289.44"
					x2="658.93"
					y2="294.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="297.82"
					x2="658.93"
					y2="303.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="306.19"
					x2="658.93"
					y2="311.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="314.57"
					x2="658.93"
					y2="319.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="322.94"
					x2="658.93"
					y2="328.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="331.32"
					x2="658.93"
					y2="336.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="339.7"
					x2="658.93"
					y2="344.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.93"
					y1="347.94"
					x2="658.93"
					y2="349.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.06"
					y1="391.86"
					x2="447.06"
					y2="444.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.68"
					y1="529.88"
					x2="756.68"
					y2="717.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m642.83,67.45c64.25,1.07,116.08,52.9,117.15,117.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m645.78,50.09c71.74,2.61,129.24,60.27,131.65,132.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.41"
					y1="524.29"
					x2="283.41"
					y2="562.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.41"
					y1="562.21"
					x2="309.36"
					y2="562.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.36"
					y1="562.21"
					x2="309.36"
					y2="524.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.36"
					y1="524.29"
					x2="283.41"
					y2="524.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="649.69 67.45 645.33 67.45 645.33 54.37 649.69 54.37 649.69 67.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="649.69"
					y1="67.45"
					x2="645.33"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.33"
					y1="67.45"
					x2="645.33"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.33"
					y1="54.37"
					x2="649.69"
					y2="54.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.69"
					y1="54.37"
					x2="649.69"
					y2="67.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="759.98 182.1 759.98 177.74 773.06 177.74 773.06 182.1 759.98 182.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.98"
					y1="182.1"
					x2="759.98"
					y2="177.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.98"
					y1="177.74"
					x2="773.06"
					y2="177.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.06"
					y1="177.74"
					x2="773.06"
					y2="182.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.06"
					y1="182.1"
					x2="759.98"
					y2="182.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.1"
					y1="418.04"
					x2="680.71"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.57"
					y1="418.04"
					x2="672.34"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.2"
					y1="418.04"
					x2="663.96"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.82"
					y1="418.04"
					x2="655.59"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.45"
					y1="418.04"
					x2="647.21"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.07"
					y1="418.04"
					x2="638.84"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.7"
					y1="418.04"
					x2="630.46"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.32"
					y1="418.04"
					x2="622.09"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.95"
					y1="418.04"
					x2="613.71"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.57"
					y1="418.04"
					x2="605.34"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.2"
					y1="418.04"
					x2="596.96"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.82"
					y1="418.04"
					x2="588.59"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.44"
					y1="418.04"
					x2="580.21"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.07"
					y1="418.04"
					x2="571.83"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.69"
					y1="418.04"
					x2="563.46"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.32"
					y1="418.04"
					x2="555.09"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.94"
					y1="418.04"
					x2="546.71"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.57"
					y1="418.04"
					x2="538.34"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.2"
					y1="418.04"
					x2="529.96"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.82"
					y1="418.04"
					x2="521.58"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.44"
					y1="418.04"
					x2="513.21"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.07"
					y1="418.04"
					x2="504.83"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.69"
					y1="418.04"
					x2="496.46"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.32"
					y1="418.04"
					x2="488.08"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.94"
					y1="418.04"
					x2="479.71"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.56"
					y1="418.04"
					x2="471.33"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.19"
					y1="418.04"
					x2="462.96"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.82"
					y1="418.04"
					x2="454.58"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.44"
					y1="418.04"
					x2="447.06"
					y2="418.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="340.31 513.01 340.31 507.77 267.54 507.77 267.54 584.72 340.31 584.72 340.31 574.09 351.21 574.09 351.21 689.21 340.31 689.21 340.31 677.58 287.12 677.58 287.12 754.1 340.31 754.1 340.31 745.92 351.21 745.92 351.21 765.01 309.98 765.01 309.98 895.81 326.29 895.81 326.29 913.27 292.54 913.27 292.54 771.56 269.68 771.56 269.68 660.13 333.76 660.13 333.76 602.16 250.09 602.16 250.09 471.59 333.76 471.59 333.76 365.74 222.58 365.74 222.58 50 317.73 50 317.73 67.46 293.2 67.46 293.2 138.16 240.02 138.16 240.02 348.29 351.21 348.29 351.21 513.01 340.31 513.01"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
				<polygon
					points="777.42 717.35 777.42 950 506.94 950 506.94 913.27 409.17 913.27 409.17 895.81 513.49 895.81 513.49 858.86 524.39 858.86 524.39 932.54 659.32 932.54 659.32 906.48 726.3 906.48 726.3 775.71 524.39 775.71 524.39 780.33 513.49 780.33 513.49 775.71 447.06 775.71 447.06 558.05 457.97 558.05 457.97 764.81 738.73 764.81 738.73 717.35 777.42 717.35"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
				<polygon
					points="645.33 50 645.33 67.45 488.46 67.45 488.46 50 645.33 50 645.33 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
				<polygon
					points="777.42 182.1 777.42 529.88 670.46 529.88 670.46 518.98 685.18 518.98 685.18 470.64 557.08 470.64 557.08 518.98 569.03 518.98 569.03 529.88 546.18 529.88 546.18 470.64 457.97 470.64 457.97 479.54 447.06 479.54 447.06 444.2 711.27 444.2 711.27 349.57 730.35 349.57 730.35 276.44 759.98 276.44 759.98 244.39 738.73 244.39 738.73 186.98 759.98 186.98 759.98 182.1 777.42 182.1"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.25"
				/>
			</g>
			<g id="text">
				<path d="m468.34,435.56v-10.11h3.48c.79,0,1.39.05,1.8.14.58.13,1.07.37,1.48.72.53.45.93,1.03,1.19,1.73.27.7.4,1.5.4,2.4,0,.77-.09,1.45-.27,2.04-.18.59-.41,1.09-.69,1.48-.28.39-.59.69-.92.92-.33.22-.73.39-1.21.5-.47.11-1.01.17-1.62.17h-3.65Zm1.34-1.19h2.16c.67,0,1.19-.06,1.57-.19.38-.12.69-.3.91-.52.32-.32.56-.74.74-1.28.18-.54.27-1.19.27-1.95,0-1.06-.17-1.87-.52-2.44-.34-.57-.77-.95-1.26-1.15-.36-.14-.94-.21-1.73-.21h-2.13v7.73Zm10.64,1.19l-2.68-10.11h1.37l1.54,6.63c.17.69.31,1.38.43,2.07.26-1.08.41-1.7.46-1.87l1.92-6.83h1.61l1.45,5.12c.36,1.27.63,2.46.79,3.58.13-.64.3-1.37.5-2.2l1.59-6.5h1.35l-2.77,10.11h-1.29l-2.13-7.71c-.18-.64-.29-1.04-.32-1.19-.11.46-.2.86-.3,1.19l-2.15,7.71h-1.37Z" />
				<path d="m687.53,319.06h-1.42l-1.7-2.85c-.16-.27-.31-.49-.45-.67-.15-.19-.3-.34-.45-.46-.15-.12-.32-.2-.5-.26-.18-.06-.37-.09-.6-.09h-.98v4.33h-1.19v-10.18h3.04c.44,0,.85.06,1.23.17.38.11.71.28.98.5.28.23.5.51.65.85.16.34.23.73.23,1.19,0,.36-.05.68-.16.98-.1.29-.26.56-.45.79-.19.23-.43.43-.71.6-.27.16-.58.29-.93.38v.03c.17.08.32.16.44.26.13.09.25.21.36.34.11.13.22.28.33.45.11.17.24.36.38.58l1.91,3.06Zm-6.11-9.1v3.69h1.62c.3,0,.57-.04.82-.13.26-.09.48-.22.66-.38.18-.17.33-.38.43-.62.1-.25.16-.52.16-.82,0-.54-.18-.97-.53-1.27-.35-.31-.86-.46-1.53-.46h-1.63Zm13.06,5.76h-5.13c.02.81.24,1.43.65,1.87.42.44.99.66,1.72.66.82,0,1.57-.27,2.26-.81v1.09c-.64.46-1.48.7-2.54.7s-1.83-.33-2.42-.99c-.59-.66-.88-1.59-.88-2.79,0-1.13.32-2.05.96-2.76.64-.71,1.44-1.07,2.39-1.07s1.69.31,2.21.92c.52.62.78,1.47.78,2.56v.61Zm-1.19-.99c0-.67-.17-1.2-.49-1.57-.32-.37-.76-.56-1.33-.56s-1.02.2-1.4.59c-.38.39-.62.91-.71,1.54h3.93Zm6.42-5.41c-.23-.13-.49-.19-.77-.19-.81,0-1.22.51-1.22,1.54v1.12h1.7v.99h-1.7v6.28h-1.16v-6.28h-1.24v-.99h1.24v-1.18c0-.76.22-1.36.66-1.8.44-.45.99-.67,1.65-.67.36,0,.64.04.85.13v1.05Z" />
				<path d="m700.94,319.22c-.22,0-.4-.08-.56-.23-.15-.16-.23-.34-.23-.56s.08-.4.23-.56c.16-.16.34-.24.56-.24s.41.08.57.24c.16.16.23.34.23.56s-.08.4-.23.56c-.16.16-.35.23-.57.23Z" />
				<path d="m598.43,841.74v-15.81h4.5c1.37,0,2.45.33,3.25,1,.8.67,1.2,1.54,1.2,2.61,0,.9-.24,1.68-.73,2.34-.49.66-1.15,1.13-2.01,1.41v.04c1.07.13,1.92.53,2.56,1.21.64.68.96,1.56.96,2.65,0,1.35-.49,2.45-1.46,3.29-.97.84-2.19,1.26-3.67,1.26h-4.61Zm1.85-14.14v5.11h1.9c1.01,0,1.81-.24,2.39-.73.58-.49.87-1.18.87-2.07,0-1.54-1.01-2.3-3.03-2.3h-2.13Zm0,6.77v5.69h2.51c1.09,0,1.93-.26,2.53-.77.6-.51.9-1.22.9-2.12,0-1.87-1.27-2.8-3.82-2.8h-2.13Zm18.92,7.37h-1.81v-1.76h-.04c-.79,1.35-1.94,2.03-3.47,2.03-1.12,0-2.01-.3-2.65-.89-.63-.6-.95-1.39-.95-2.37,0-2.11,1.24-3.34,3.73-3.68l3.39-.47c0-1.92-.78-2.88-2.33-2.88-1.36,0-2.59.46-3.68,1.39v-1.85c1.11-.71,2.39-1.06,3.84-1.06,2.65,0,3.98,1.4,3.98,4.21v7.34Zm-1.81-5.71l-2.72.37c-.84.12-1.47.33-1.9.63-.43.29-.64.82-.64,1.58,0,.55.19,1,.58,1.36.4.35.92.52,1.58.52.9,0,1.64-.31,2.22-.94.59-.63.88-1.43.88-2.39v-1.12Zm10.46,5.6c-.43.24-.99.35-1.69.35-1.98,0-2.97-1.1-2.97-3.31v-6.68h-1.94v-1.54h1.94v-2.76l1.81-.58v3.34h2.84v1.54h-2.84v6.36c0,.76.13,1.3.39,1.62.26.32.68.49,1.28.49.46,0,.85-.12,1.18-.37v1.54Zm11.79.11h-1.81v-6.51c0-2.35-.87-3.53-2.62-3.53-.88,0-1.62.34-2.23,1.03-.6.68-.9,1.55-.9,2.61v6.4h-1.81v-16.72h1.81v7.3h.04c.87-1.43,2.1-2.14,3.7-2.14,2.54,0,3.82,1.53,3.82,4.6v6.96Z" />
				<path d="m363.61,822.08h-8.38v-15.81h8.03v1.68h-6.18v5.26h5.71v1.67h-5.71v5.54h6.53v1.68Zm12.19,0h-1.81v-6.44c0-2.4-.87-3.59-2.62-3.59-.9,0-1.65.34-2.25,1.03-.59.68-.88,1.53-.88,2.57v6.44h-1.81v-11.29h1.81v1.87h.04c.85-1.43,2.09-2.14,3.71-2.14,1.23,0,2.18.4,2.83,1.2.65.79.98,1.94.98,3.45v6.9Zm8.66-.11c-.43.24-.99.35-1.69.35-1.98,0-2.97-1.1-2.97-3.31v-6.68h-1.94v-1.54h1.94v-2.76l1.81-.58v3.34h2.84v1.54h-2.84v6.36c0,.76.13,1.3.39,1.62.26.32.68.49,1.28.49.46,0,.85-.13,1.18-.37v1.54Zm8.32-9.35c-.32-.24-.77-.36-1.37-.36-.77,0-1.42.36-1.94,1.09-.51.73-.77,1.72-.77,2.98v5.76h-1.81v-11.29h1.81v2.33h.04c.26-.79.65-1.41,1.18-1.85.53-.45,1.12-.67,1.78-.67.47,0,.83.05,1.08.15v1.87Zm10.97-1.83l-5.19,13.1c-.93,2.34-2.23,3.51-3.9,3.51-.47,0-.86-.05-1.18-.14v-1.62c.39.13.75.2,1.07.2.91,0,1.6-.54,2.05-1.63l.9-2.14-4.41-11.27h2.01l3.05,8.69c.04.11.11.4.23.86h.07c.04-.18.11-.46.22-.84l3.21-8.71h1.87Z" />
				<path d="m565.2,645.81v-15.81h4.5c1.37,0,2.45.33,3.25,1,.8.67,1.2,1.54,1.2,2.61,0,.9-.24,1.68-.73,2.34-.49.66-1.15,1.13-2.01,1.41v.04c1.07.12,1.92.53,2.56,1.21.64.68.96,1.56.96,2.65,0,1.35-.49,2.45-1.46,3.29-.97.84-2.19,1.26-3.67,1.26h-4.61Zm1.85-14.14v5.11h1.9c1.01,0,1.81-.24,2.39-.73.58-.49.87-1.18.87-2.07,0-1.54-1.01-2.3-3.03-2.3h-2.13Zm0,6.77v5.69h2.51c1.09,0,1.93-.26,2.53-.77.6-.51.9-1.22.9-2.12,0-1.87-1.27-2.8-3.82-2.8h-2.13Zm19.9,2.17h-7.97c.03,1.26.37,2.23,1.01,2.91.65.68,1.54,1.03,2.67,1.03,1.27,0,2.44-.42,3.51-1.26v1.7c-.99.72-2.3,1.08-3.94,1.08s-2.85-.51-3.76-1.53c-.91-1.03-1.37-2.47-1.37-4.33,0-1.76.5-3.19,1.49-4.29,1-1.11,2.24-1.67,3.72-1.67s2.62.48,3.43,1.43c.81.96,1.21,2.28,1.21,3.98v.95Zm-1.85-1.53c0-1.04-.26-1.86-.76-2.44-.49-.58-1.18-.87-2.06-.87s-1.58.31-2.17.92-.96,1.41-1.1,2.39h6.1Zm14.21,6.73h-1.81v-1.92h-.04c-.84,1.46-2.13,2.18-3.88,2.18-1.42,0-2.55-.5-3.41-1.51-.85-1.01-1.27-2.39-1.27-4.14,0-1.87.47-3.36,1.41-4.49.94-1.12,2.19-1.69,3.76-1.69s2.68.61,3.39,1.83h.04v-6.99h1.81v16.72Zm-1.81-5.11v-1.67c0-.91-.3-1.68-.9-2.32-.6-.63-1.37-.95-2.29-.95-1.1,0-1.97.4-2.6,1.21-.63.81-.95,1.93-.95,3.35,0,1.3.3,2.33.9,3.09.61.75,1.43,1.12,2.45,1.12s1.82-.36,2.45-1.09c.63-.73.95-1.65.95-2.76Zm11.34-4.36c-.32-.24-.77-.36-1.37-.36-.77,0-1.42.36-1.94,1.09-.51.73-.77,1.72-.77,2.98v5.76h-1.81v-11.29h1.81v2.33h.04c.26-.79.65-1.41,1.18-1.85.53-.45,1.12-.67,1.78-.67.47,0,.83.05,1.08.15v1.87Zm6.67,9.73c-1.67,0-3-.53-4-1.58-.99-1.06-1.49-2.46-1.49-4.2,0-1.9.52-3.38,1.55-4.44s2.44-1.6,4.2-1.6,3,.52,3.94,1.55c.95,1.04,1.42,2.47,1.42,4.31s-.51,3.25-1.53,4.33c-1.01,1.08-2.38,1.62-4.09,1.62Zm.13-10.3c-1.16,0-2.08.4-2.76,1.19-.68.79-1.01,1.87-1.01,3.26s.34,2.39,1.03,3.16c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.83.95-3.23s-.32-2.5-.95-3.26c-.62-.76-1.52-1.15-2.69-1.15Zm13.08,10.3c-1.67,0-3-.53-4-1.58-.99-1.06-1.49-2.46-1.49-4.2,0-1.9.52-3.38,1.55-4.44,1.04-1.07,2.44-1.6,4.2-1.6s3,.52,3.94,1.55c.95,1.04,1.42,2.47,1.42,4.31s-.51,3.25-1.53,4.33c-1.01,1.08-2.38,1.62-4.09,1.62Zm.13-10.3c-1.16,0-2.08.4-2.76,1.19-.68.79-1.01,1.87-1.01,3.26s.34,2.39,1.03,3.16c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.83.95-3.23s-.32-2.5-.95-3.26c-.62-.76-1.52-1.15-2.69-1.15Zm24.39,10.03h-1.81v-6.48c0-1.25-.19-2.15-.58-2.71-.38-.56-1.03-.84-1.94-.84-.77,0-1.43.35-1.97,1.06-.54.71-.8,1.55-.8,2.54v6.44h-1.81v-6.7c0-2.22-.86-3.33-2.57-3.33-.79,0-1.45.33-1.96,1-.51.66-.77,1.53-.77,2.59v6.44h-1.81v-11.29h1.81v1.79h.04c.8-1.37,1.97-2.05,3.51-2.05.77,0,1.44.22,2.02.65.57.43.97.99,1.18,1.69.84-1.56,2.09-2.34,3.75-2.34,2.48,0,3.73,1.53,3.73,4.6v6.96Z" />
				<path d="m569.72,669.24h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Zm8.87,0h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Z" />
				<rect x="582.96" y="657.74" width="1.16" height="3.58" />
				<path d="m593.57,665.59c0,.56-.09,1.08-.27,1.55-.18.47-.43.88-.75,1.22-.32.34-.7.61-1.15.8-.44.19-.92.28-1.44.28-.58,0-1.1-.12-1.56-.36-.45-.24-.84-.59-1.16-1.03-.32-.45-.56-1.01-.72-1.66-.17-.65-.25-1.39-.25-2.2,0-1,.11-1.91.33-2.72.22-.82.54-1.52.95-2.09.41-.58.91-1.03,1.48-1.35s1.22-.47,1.93-.47c.79,0,1.43.11,1.91.33v1.24c-.59-.3-1.22-.46-1.88-.46-.51,0-.98.11-1.39.34-.41.23-.76.56-1.06.98-.29.42-.52.92-.68,1.52-.15.59-.23,1.25-.23,1.98h.03c.53-.96,1.4-1.44,2.62-1.44.5,0,.95.09,1.35.26.41.17.75.41,1.03.73.29.31.51.68.67,1.11.15.43.23.91.23,1.44Zm-1.35.17c0-.4-.05-.76-.15-1.08-.1-.32-.25-.59-.44-.82-.19-.22-.42-.4-.7-.51-.28-.12-.59-.18-.95-.18-.33,0-.63.06-.91.18-.28.12-.52.29-.72.51-.2.21-.36.45-.48.74-.11.28-.17.57-.17.89,0,.4.06.77.17,1.11.11.34.27.64.47.9.2.26.44.46.72.61.28.14.6.22.94.22s.63-.06.91-.18c.27-.13.51-.3.7-.53.19-.22.34-.49.45-.8.11-.32.16-.66.16-1.04Z" />
				<path d="m596.71,657.74v3.58h-1.16v-3.58h1.16Zm2.66,0v3.58h-1.16v-3.58h1.16Z" />
				<path d="m612.52,661.03l-2.76,4.15,2.71,4.06h-1.53l-1.61-2.66c-.1-.17-.22-.37-.36-.63h-.03s-.15.26-.38.63l-1.64,2.66h-1.52l2.8-4.02-2.68-4.18h1.53l1.59,2.81c.12.21.23.42.34.64h.03l2.05-3.45h1.45Z" />
				<path d="m617.96,666.03c0-.3.05-.61.14-.91.1-.31.23-.6.41-.87.18-.27.4-.51.67-.73.27-.22.57-.39.91-.52-.5-.28-.89-.63-1.19-1.07-.29-.44-.44-.92-.44-1.45,0-.42.08-.81.24-1.17.17-.36.39-.67.68-.93s.63-.46,1.03-.61c.4-.15.82-.22,1.28-.22s.9.07,1.29.22c.4.15.74.36,1.03.62.29.26.51.57.67.93.16.36.24.75.24,1.16,0,.53-.15,1.01-.44,1.45-.29.43-.68.79-1.17,1.07.33.13.63.3.89.52.26.22.48.46.66.73.18.27.32.56.42.87.1.3.14.61.14.91,0,.5-.09.96-.27,1.38-.18.42-.44.77-.77,1.07-.33.29-.72.52-1.18.69-.45.17-.96.25-1.51.25s-1.04-.08-1.5-.25-.85-.4-1.18-.69c-.33-.3-.59-.66-.78-1.07-.18-.42-.27-.88-.27-1.38Zm1.43-.11c0,.36.05.68.16.97.11.29.27.53.46.74.2.2.45.36.73.47.29.11.61.16.95.16s.65-.06.93-.17c.28-.11.53-.27.73-.47.21-.2.37-.45.48-.74.12-.29.18-.61.18-.96,0-.32-.06-.62-.17-.9-.11-.28-.26-.53-.46-.75-.2-.21-.45-.38-.73-.51-.28-.12-.6-.18-.95-.18-.33,0-.64.06-.92.18-.28.11-.52.27-.73.48-.2.2-.36.45-.48.74-.12.28-.18.6-.18.94Zm.41-5.33c0,.27.05.53.14.76.1.23.24.43.41.61.18.17.38.31.61.41.23.1.48.14.74.14s.51-.05.74-.15c.24-.1.44-.24.61-.41.17-.18.31-.38.41-.61.1-.24.15-.49.15-.75s-.05-.53-.15-.77c-.1-.24-.23-.44-.4-.61-.17-.17-.37-.3-.61-.4-.23-.1-.48-.15-.75-.15-.28,0-.54.05-.78.15-.23.1-.43.24-.6.42-.17.17-.29.37-.38.61-.09.24-.14.49-.14.75Z" />
				<rect x="627.41" y="657.74" width="1.16" height="3.58" />
				<path d="m635.63,669.24h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Zm8.87,0h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Z" />
				<path d="m650.03,657.74v3.58h-1.16v-3.58h1.16Zm2.66,0v3.58h-1.16v-3.58h1.16Z" />
				<path d="m525.2,343.56h-2.58l-6.11-7.23c-.23-.27-.37-.46-.42-.55h-.04v7.78h-1.85v-15.81h1.85v7.43h.04c.1-.16.24-.34.42-.54l5.91-6.89h2.3l-6.78,7.59,7.26,8.23Zm2.76-14.16c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.16h-1.81v-11.29h1.81v11.29Zm8.88-.11c-.43.24-.99.35-1.69.35-1.98,0-2.97-1.1-2.97-3.31v-6.68h-1.94v-1.54h1.94v-2.76l1.81-.58v3.34h2.84v1.54h-2.84v6.36c0,.76.13,1.3.39,1.62.26.32.68.49,1.28.49.46,0,.85-.12,1.18-.37v1.54Zm10.1-.41c-.87.52-1.9.78-3.09.78-1.61,0-2.91-.52-3.9-1.57-.99-1.05-1.48-2.41-1.48-4.08,0-1.86.53-3.35,1.6-4.48,1.07-1.13,2.49-1.7,4.27-1.7.99,0,1.87.18,2.62.55v1.85c-.84-.59-1.73-.88-2.69-.88-1.15,0-2.1.42-2.84,1.25-.74.82-1.1,1.91-1.1,3.25s.35,2.37,1.04,3.13c.7.76,1.63,1.15,2.8,1.15.99,0,1.91-.33,2.78-.98v1.72Zm12.09.52h-1.81v-6.51c0-2.35-.87-3.53-2.62-3.53-.88,0-1.62.34-2.23,1.03-.6.68-.9,1.55-.9,2.61v6.4h-1.81v-16.72h1.81v7.3h.04c.87-1.43,2.1-2.14,3.7-2.14,2.54,0,3.82,1.53,3.82,4.6v6.96Zm12.47-5.19h-7.97c.03,1.26.37,2.23,1.01,2.91.65.68,1.54,1.03,2.67,1.03,1.27,0,2.44-.42,3.51-1.26v1.7c-.99.72-2.3,1.08-3.94,1.08s-2.85-.51-3.76-1.53c-.91-1.03-1.37-2.47-1.37-4.33,0-1.76.5-3.19,1.49-4.29,1-1.11,2.24-1.67,3.72-1.67s2.62.48,3.43,1.43c.81.96,1.21,2.28,1.21,3.98v.95Zm-1.85-1.53c0-1.04-.26-1.86-.76-2.44-.49-.58-1.18-.87-2.06-.87s-1.58.31-2.17.92c-.6.61-.96,1.41-1.1,2.39h6.1Zm13.94,6.73h-1.81v-6.44c0-2.4-.87-3.59-2.62-3.59-.9,0-1.65.34-2.25,1.03-.59.68-.88,1.53-.88,2.57v6.44h-1.81v-11.29h1.81v1.87h.04c.85-1.43,2.09-2.14,3.71-2.14,1.23,0,2.18.4,2.83,1.2.65.79.98,1.94.98,3.45v6.9Z" />
				<path d="m394.02,224.94h-8.2v-15.81h1.85v14.14h6.35v1.68Zm3.11-14.16c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.16h-1.81v-11.29h1.81v11.29Zm12.52-11.29l-4.5,11.29h-1.78l-4.28-11.29h1.98l2.87,8.2c.21.6.35,1.13.4,1.58h.04c.07-.57.19-1.08.35-1.53l3-8.25h1.91Zm2.86-2.87c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.16h-1.81v-11.29h1.81v11.29Zm13.02,0h-1.81v-6.44c0-2.4-.87-3.59-2.62-3.59-.9,0-1.65.34-2.25,1.03-.59.68-.88,1.53-.88,2.57v6.44h-1.81v-11.29h1.81v1.87h.04c.85-1.43,2.09-2.14,3.71-2.14,1.23,0,2.18.4,2.83,1.2.65.79.98,1.94.98,3.45v6.9Zm13.04-.9c0,4.15-1.98,6.22-5.95,6.22-1.4,0-2.62-.26-3.66-.79v-1.81c1.27.71,2.48,1.06,3.64,1.06,2.78,0,4.17-1.48,4.17-4.43v-1.23h-.04c-.86,1.44-2.15,2.16-3.88,2.16-1.4,0-2.54-.5-3.4-1.5-.85-1.01-1.28-2.36-1.28-4.05,0-1.92.46-3.44,1.38-4.58.93-1.13,2.19-1.7,3.79-1.7s2.65.61,3.39,1.83h.04v-1.57h1.81v10.39Zm-1.81-4.2v-1.67c0-.9-.31-1.67-.92-2.3-.6-.64-1.36-.96-2.26-.96-1.12,0-1.99.41-2.62,1.22-.63.81-.95,1.94-.95,3.41,0,1.26.3,2.26.9,3.02.61.75,1.42,1.12,2.41,1.12s1.84-.36,2.47-1.08c.64-.72.96-1.64.96-2.77Z" />
				<polygon points="451.11 209.12 443.52 227.56 441.84 227.56 449.4 209.12 451.11 209.12" />
				<path d="m452.95,224.94v-15.81h4.37c5.57,0,8.36,2.57,8.36,7.71,0,2.44-.78,4.4-2.33,5.89-1.54,1.48-3.61,2.22-6.21,2.22h-4.19Zm1.85-14.14v12.46h2.36c2.07,0,3.69-.56,4.84-1.67,1.15-1.11,1.73-2.68,1.73-4.72,0-4.05-2.15-6.08-6.46-6.08h-2.47Zm14.59-.02c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.16h-1.81v-11.29h1.81v11.29Zm12.96,0h-1.81v-6.44c0-2.4-.87-3.59-2.62-3.59-.9,0-1.65.34-2.25,1.03-.59.68-.88,1.53-.88,2.57v6.44h-1.81v-11.29h1.81v1.87h.04c.85-1.43,2.09-2.14,3.71-2.14,1.24,0,2.18.4,2.83,1.2.65.79.98,1.94.98,3.45v6.9Zm4.27-14.16c-.32,0-.6-.11-.83-.33-.23-.22-.34-.5-.34-.84s.11-.62.34-.84c.23-.23.5-.34.83-.34s.61.11.84.34c.24.22.35.5.35.84s-.12.6-.35.83c-.23.23-.51.34-.84.34Zm.88,14.16h-1.81v-11.29h1.81v11.29Zm12.96,0h-1.81v-6.44c0-2.4-.87-3.59-2.62-3.59-.9,0-1.65.34-2.25,1.03-.59.68-.88,1.53-.88,2.57v6.44h-1.81v-11.29h1.81v1.87h.04c.85-1.43,2.09-2.14,3.7-2.14,1.24,0,2.18.4,2.83,1.2.65.79.98,1.94.98,3.45v6.9Zm12.98-.9c0,4.15-1.98,6.22-5.95,6.22-1.4,0-2.62-.26-3.66-.79v-1.81c1.27.71,2.48,1.06,3.64,1.06,2.78,0,4.17-1.48,4.17-4.43v-1.23h-.04c-.86,1.44-2.15,2.16-3.88,2.16-1.4,0-2.54-.5-3.4-1.5-.85-1.01-1.28-2.36-1.28-4.05,0-1.92.46-3.44,1.38-4.58.93-1.13,2.19-1.7,3.79-1.7s2.65.61,3.39,1.83h.04v-1.57h1.81v10.39Zm-1.81-4.2v-1.67c0-.9-.31-1.67-.92-2.3-.6-.64-1.36-.96-2.26-.96-1.12,0-1.99.41-2.62,1.22-.63.81-.95,1.94-.95,3.41,0,1.26.3,2.26.9,3.02.61.75,1.42,1.12,2.41,1.12s1.84-.36,2.47-1.08c.64-.72.96-1.64.96-2.77Z" />
				<path d="m535.94,224.94h-2.21l-2.65-4.43c-.24-.41-.48-.76-.71-1.05-.23-.29-.46-.53-.71-.72-.24-.18-.49-.32-.77-.4-.27-.09-.58-.13-.93-.13h-1.52v6.73h-1.85v-15.81h4.72c.69,0,1.33.09,1.91.26.59.17,1.1.43,1.52.78.43.35.77.79,1.01,1.32.24.52.36,1.14.36,1.84,0,.55-.08,1.06-.25,1.52-.16.46-.4.86-.71,1.22-.3.36-.67.67-1.1.93-.43.25-.91.44-1.44.58v.04c.26.12.49.25.68.41.2.15.39.32.56.53.18.21.35.44.52.71.18.26.37.56.58.9l2.97,4.75Zm-9.48-14.14v5.73h2.51c.46,0,.89-.07,1.28-.21.4-.14.74-.34,1.03-.6.29-.26.51-.58.67-.96.16-.38.24-.81.24-1.28,0-.85-.28-1.5-.83-1.97-.54-.48-1.33-.72-2.37-.72h-2.54Zm16.06,14.4c-1.67,0-3-.53-4-1.58-.99-1.06-1.49-2.46-1.49-4.2,0-1.9.52-3.38,1.55-4.44,1.04-1.07,2.44-1.6,4.2-1.6s3,.52,3.94,1.55c.95,1.04,1.42,2.47,1.42,4.31s-.51,3.25-1.53,4.33c-1.01,1.08-2.38,1.62-4.09,1.62Zm.13-10.3c-1.16,0-2.08.4-2.76,1.19-.68.79-1.01,1.87-1.01,3.26s.34,2.39,1.03,3.16c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.83.95-3.23s-.32-2.5-.95-3.26c-.62-.76-1.52-1.15-2.69-1.15Zm13.03,10.3c-1.67,0-3-.53-4-1.58-.99-1.06-1.49-2.46-1.49-4.2,0-1.9.52-3.38,1.55-4.44,1.04-1.07,2.44-1.6,4.2-1.6s3,.52,3.94,1.55c.95,1.04,1.42,2.47,1.42,4.31s-.51,3.25-1.53,4.33c-1.01,1.08-2.38,1.62-4.09,1.62Zm.13-10.3c-1.16,0-2.08.4-2.76,1.19-.68.79-1.01,1.87-1.01,3.26s.34,2.39,1.03,3.16c.68.77,1.6,1.16,2.75,1.16s2.07-.38,2.69-1.14c.63-.76.95-1.83.95-3.23s-.32-2.5-.95-3.26c-.62-.76-1.52-1.15-2.69-1.15Zm24.34,10.03h-1.81v-6.48c0-1.25-.19-2.15-.58-2.71-.38-.56-1.03-.84-1.94-.84-.77,0-1.43.35-1.97,1.06-.54.71-.81,1.55-.81,2.54v6.44h-1.81v-6.7c0-2.22-.86-3.33-2.57-3.33-.79,0-1.45.33-1.96,1-.51.66-.77,1.53-.77,2.59v6.44h-1.81v-11.29h1.81v1.79h.04c.8-1.37,1.97-2.05,3.51-2.05.77,0,1.44.22,2.02.65.57.43.97.99,1.18,1.69.84-1.56,2.09-2.34,3.75-2.34,2.48,0,3.73,1.53,3.73,4.6v6.96Z" />
				<path d="m438.88,248.37h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Zm11.11-6.44c0,1.05-.1,1.99-.31,2.81-.21.82-.51,1.51-.91,2.08-.4.57-.89,1-1.47,1.3-.58.29-1.23.44-1.97.44s-1.43-.13-2-.4v-1.26c.64.36,1.31.54,2.04.54.52,0,.98-.11,1.39-.32.41-.21.76-.52,1.04-.93.28-.41.5-.92.65-1.52.15-.6.22-1.29.22-2.06h-.03c-.49.99-1.35,1.48-2.57,1.48-.49,0-.94-.09-1.35-.26-.41-.18-.77-.42-1.07-.74-.3-.32-.53-.7-.7-1.14-.17-.44-.25-.92-.25-1.45,0-.57.09-1.08.27-1.56.19-.47.44-.87.77-1.21.33-.34.72-.61,1.17-.79.45-.19.95-.28,1.48-.28.58,0,1.09.12,1.53.35.45.23.83.57,1.13,1.02.3.44.54.99.7,1.64.16.65.24,1.4.24,2.24Zm-1.42-1.18c0-.44-.06-.85-.18-1.21-.11-.36-.27-.67-.47-.93-.2-.26-.45-.46-.73-.6-.28-.14-.58-.22-.91-.22s-.61.06-.88.19c-.27.12-.51.3-.71.53-.2.22-.36.49-.47.81-.11.31-.17.65-.17,1.02,0,.41.05.77.16,1.09.11.32.27.59.47.82.2.22.45.39.73.51.29.12.61.18.95.18.3,0,.59-.06.86-.17.27-.12.51-.27.71-.46.2-.2.36-.43.47-.69.12-.27.18-.55.18-.86Z" />
				<rect x="452.12" y="236.88" width="1.16" height="3.58" />
				<path d="m460.34,248.37h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Zm11.24-5.8c0,.96-.09,1.81-.26,2.56-.17.74-.42,1.37-.75,1.88-.33.51-.73.9-1.21,1.16-.48.26-1.02.39-1.63.39-.58,0-1.09-.13-1.55-.38-.45-.26-.83-.63-1.14-1.11-.31-.49-.55-1.08-.71-1.79-.16-.71-.24-1.52-.24-2.44,0-1,.08-1.89.25-2.66.17-.77.42-1.41.75-1.93.33-.52.73-.92,1.21-1.18.49-.27,1.04-.4,1.67-.4,2.41,0,3.62,1.96,3.62,5.89Zm-1.35.13c0-3.27-.78-4.91-2.33-4.91-1.64,0-2.46,1.66-2.46,4.99,0,3.11.8,4.66,2.41,4.66s2.38-1.58,2.38-4.75Z" />
				<path d="m474.74,236.88v3.58h-1.16v-3.58h1.16Zm2.66,0v3.58h-1.16v-3.58h1.16Z" />
				<path d="m490.55,240.16l-2.76,4.15,2.71,4.06h-1.53l-1.61-2.66c-.1-.17-.22-.37-.36-.63h-.03s-.15.26-.38.63l-1.64,2.66h-1.52l2.8-4.02-2.68-4.18h1.53l1.59,2.81c.12.21.23.42.34.64h.03l2.05-3.45h1.45Z" />
				<path d="m501.07,248.37h-1.31v-9.93c-.1.1-.25.22-.45.35-.19.13-.41.26-.66.38-.24.13-.5.25-.77.36-.27.11-.53.2-.79.26v-1.33c.29-.08.59-.19.91-.32.33-.14.64-.29.95-.46.32-.17.61-.35.89-.53.28-.19.52-.37.72-.55h.5v11.75Zm11.24-5.8c0,.96-.09,1.81-.26,2.56-.17.74-.42,1.37-.75,1.88-.33.51-.73.9-1.21,1.16-.48.26-1.02.39-1.63.39-.58,0-1.09-.13-1.55-.38-.45-.26-.83-.63-1.14-1.11-.31-.49-.55-1.08-.71-1.79-.16-.71-.24-1.52-.24-2.44,0-1,.08-1.89.25-2.66.17-.77.42-1.41.75-1.93.33-.52.73-.92,1.21-1.18.49-.27,1.04-.4,1.67-.4,2.41,0,3.62,1.96,3.62,5.89Zm-1.35.13c0-3.27-.78-4.91-2.33-4.91-1.64,0-2.46,1.66-2.46,4.99,0,3.11.8,4.66,2.41,4.66s2.38-1.58,2.38-4.75Z" />
				<rect x="514.31" y="236.88" width="1.16" height="3.58" />
				<path d="m517.44,245.17c0-.3.05-.61.14-.91.1-.31.23-.6.41-.87.18-.27.4-.51.67-.73.27-.22.57-.39.91-.52-.5-.28-.89-.63-1.19-1.07-.29-.44-.44-.92-.44-1.45,0-.42.08-.81.24-1.17.17-.36.39-.67.68-.93.29-.26.63-.46,1.03-.61.4-.15.82-.22,1.28-.22s.9.07,1.29.22c.4.15.74.36,1.03.62.29.26.51.57.67.93.16.36.24.75.24,1.16,0,.53-.15,1.01-.44,1.45-.29.43-.68.79-1.17,1.07.33.13.63.3.89.52.26.22.48.46.66.73.18.27.32.56.42.87.1.3.14.61.14.91,0,.5-.09.96-.27,1.38-.18.42-.44.77-.77,1.07-.33.29-.72.52-1.18.69-.45.17-.96.25-1.51.25s-1.04-.08-1.5-.25c-.45-.17-.85-.4-1.18-.69-.33-.3-.59-.66-.78-1.07-.18-.42-.27-.88-.27-1.38Zm1.43-.11c0,.36.05.68.16.97.11.29.27.53.47.74.2.2.45.36.73.47.29.11.61.16.95.16s.65-.06.93-.17c.28-.11.53-.27.73-.47.21-.2.37-.45.48-.74.12-.29.18-.61.18-.96,0-.32-.06-.62-.17-.9-.11-.28-.26-.53-.46-.75-.2-.21-.45-.38-.73-.51-.28-.12-.6-.18-.95-.18-.33,0-.64.06-.92.18-.28.11-.52.27-.73.48-.2.2-.36.45-.48.74-.12.28-.18.6-.18.94Zm.41-5.33c0,.27.05.53.14.76.1.23.24.43.41.61.18.17.38.31.61.41.23.1.48.14.74.14s.51-.05.74-.15c.24-.1.44-.24.61-.41.17-.18.31-.38.41-.61.1-.24.15-.49.15-.75s-.05-.53-.15-.77c-.1-.24-.23-.44-.4-.61-.17-.17-.37-.3-.61-.4-.23-.1-.48-.15-.75-.15-.28,0-.54.05-.78.15-.23.1-.43.24-.6.42-.17.17-.29.37-.38.61-.09.24-.14.49-.14.75Z" />
				<path d="m528.06,236.88v3.58h-1.16v-3.58h1.16Zm2.66,0v3.58h-1.16v-3.58h1.16Z" />
				<path d="m295.24,539.52l-2.6,9.21h-1.27l-1.9-6.73c-.08-.29-.13-.6-.15-.94h-.03c-.03.32-.08.63-.17.93l-1.91,6.75h-1.25l-2.7-9.21h1.19l1.96,7.07c.08.3.13.6.15.93h.03c.02-.23.09-.54.2-.93l2.04-7.07h1.03l1.95,7.12c.07.24.12.53.15.86h.03c.02-.22.07-.52.17-.89l1.88-7.09h1.17Z" />
				<polygon points="300.6 539.52 296.18 550.26 295.2 550.26 299.61 539.52 300.6 539.52" />
				<path d="m301.67,548.73v-9.21h2.54c3.25,0,4.87,1.5,4.87,4.49,0,1.42-.45,2.57-1.36,3.43-.9.86-2.11,1.29-3.62,1.29h-2.44Zm1.08-8.24v7.26h1.37c1.21,0,2.15-.32,2.82-.97.67-.65,1.01-1.56,1.01-2.75,0-2.36-1.25-3.54-3.76-3.54h-1.44Z" />
			</g>
		</g>
	)
}

export default PlanGG
